module.exports = __webpack_public_path__ + "media/customizations/riverland/logo-46f461dd30cb9cdb570e5b59f00c04fd.png";